import { DateTime } from "luxon"

import { authFetch } from "@/api/authFetch.ts"
import { API_BASE } from "@/config.ts"

import type { Driver } from "../types/logisticsTypes.ts"
import type { DateRange } from "react-day-picker"

export const getDriverData = async (range?: DateRange): Promise<Driver[]> => {
  const startDate = DateTime.fromJSDate(range?.from || new Date())
    .setZone("UTC")
    .toISO()
  const endDate = DateTime.fromJSDate(range?.to || new Date())
    .setZone("UTC")
    .toISO()

  const res = await authFetch(
    `${API_BASE}/logistics/drivers?companyId=4&includeTrips=true&start=${startDate}&end=${endDate}`,
  )
  const data: Driver[] = await res.json()
  return data
    .filter((d) => d.trips && d.trips.length > 0)
    .map((d) => ({
      ...d,
      trips: d.trips?.filter((t) => t.farm != "BCO"),
    }))
}
